<!--主营业务-->
<template>
  <div>
    <!--智库服务导航图-->
    <el-row v-show="thinkTank_visible">
      <el-col :span="24">
        <div class='animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
            <el-carousel-item v-for='item in carouselList' :key='item.id'>
              <div class='block' @click='jump(item)'>
                <el-image class='image-slot'
                          :fit='fit'
                          v-if='item.imageUrl != null'
                          :src='item.imageUrl'
                />
                <h3>{{ item.name }}</h3>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row >
    <!--企业顾问导航图-->
    <el-row v-show="enterprise_visible">
      <el-col :span="24">
        <div class='animate__animated animate__zoomIn animate__slow'>
        <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in industryList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--智慧服务导航图-->
    <el-row v-show="wisdom_visible">
      <el-col :span="24">
        <div class='animate__animated animate__zoomIn animate__slow'>
        <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in doctorList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--tabs标签页-->
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <el-col :span="16">
        <div class='animate__animated animate__fadeInUp animate__slower'>
        <div class="grid-content">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <!--智库服务-->
            <el-tab-pane name="first">
              <template slot="label">
                <div class="know_item">
                    <img :src=srcUrl>
                </div>
              </template>
              <!--左边导航栏-->
              <div class='animate__animated animate__fadeInLeft animate__slow'>
                <div class='leftNavigationBar'>
                <ul>
                  <li class='newsList' v-for='item in businessDataList' :key='item.id'>
                    <a @click="doctor(item)">{{ item.name }}</a>
                  </li>
                </ul>
              </div>
              </div>
              <div class='animate__animated animate__fadeInRight animate__slow animate__delay-1s'>
                <!--内容区域-->
                <div class='contentArea'>
                  <p v-html='content'></p>
                </div>
              </div>
            </el-tab-pane>
            <!--企业顾问-->
             <el-tab-pane  name="second">
              <template slot="label">
                <div class="know_item">
                    <img :src=srcUrl1>
                </div>
              </template>
               <div class='animate__animated animate__fadeInLeft animate__slow'>
               <!--左边导航栏-->
                <div class='leftNavigationBar'>
                <ul>
                  <li class='newsList' v-for='item in enterpriseDataList' :key='item.id'>
                    <a @click="doctor(item)">{{ item.name }}</a>
                  </li>
                </ul>
              </div>
               </div>
               <div class='animate__animated animate__fadeInRight animate__slow animate__delay-1s'>
                 <!--内容区域-->
                <div class='contentArea'>
                  <p v-html='content'></p>
                </div>
               </div>
            </el-tab-pane>
            <!--智慧服务-->
            <el-tab-pane  name="third">
              <template slot="label">
                <div class="know_item">
                  <img :src=srcUrl2>
                </div>
              </template>
              <div class='animate__animated animate__fadeInLeft animate__slow'>
                <!--左边导航栏-->
                <div class='leftNavigationBar'>
                  <ul>
                    <li class='newsList' v-for='item in wisdomDataList' :key='item.id'>
                      <a @click="doctor(item)">{{ item.name }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class='animate__animated animate__fadeInRight animate__slow animate__delay-1s'>
                <!--内容区域-->
                <div class='contentArea'>
                  <p  v-html='content'></p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { businessTypeList, selectCarouselPicture } from '../../api/auth'
import 'quill/dist/quill.core.css'
export default {

  data () {
    return {
      srcUrl: require('../../assets/images/customerStories/thinkTanks1.png'),
      srcUrl1: require('../../assets/images/customerStories/enterprise2.png'),
      srcUrl2: require('../../assets/images/customerStories/wisdom2.png'),

      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      businessDataList: [],
      enterpriseDataList: [],
      wisdomDataList: [],
      thinkTank_visible: true,
      enterprise_visible: false,
      wisdom_visible: false,
      id: '',
      activeName: 'first',
      content: '',
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      queryParams: {
        type: 1
      },
      enterpriseParams: {
        type: 2
      },
      wisdomParams: {
        type: 3
      },
      businessContent: '',
      enterpriseContent: '',
      wisdomContent: '',
      carouselList: [],
      industryList: [],
      doctorList: [],
      carouselIndustryParams: {
        type: 5
      },
      carouselParams: {
        type: 5
      },
      carouselDoctorParams: {
        type: 5
      }
    }
  },
  methods: {
    jump (raw) {
    },
    /** 滚动图  */
    selectCompanyPicture (raw) {
      let that = this
      that.carouselParams.type = raw
      selectCarouselPicture(that.carouselParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.carouselList = res
      })
    },
    /** 滚动图  */
    selectIndustryPicture (raw) {
      let that = this
      that.carouselIndustryParams.type = raw
      selectCarouselPicture(that.carouselIndustryParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.industryList = res
      })
    },
    /** 滚动图  */
    selectDoctorPicture (raw) {
      let that = this
      that.carouselDoctorParams.type = raw
      selectCarouselPicture(that.carouselDoctorParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.doctorList = res
      })
    },
    /** 政府智库 */
    // eslint-disable-next-line vue/no-dupe-keys
    businessTypeList (type) {
      let that = this
      that.queryParams.type = type
      businessTypeList(that.queryParams).then(res => {
        that.businessDataList = res
        if (that.businessDataList.length !== 0) {
          that.content = that.businessDataList[0].content
          that.businessContent = that.businessDataList[0].content
        }
      })
    },
    /** 企业顾问 */
    // eslint-disable-next-line vue/no-dupe-keys
    EnterpriseList (type) {
      let that = this
      that.enterpriseParams.type = type
      businessTypeList(that.enterpriseParams).then(res => {
        that.enterpriseDataList = res
        if (that.enterpriseDataList.length !== 0) {
          that.content = that.enterpriseDataList[0].content
          that.enterpriseContent = that.enterpriseDataList[0].content
        }
      })
    },
    /** 智慧服务 */
    // eslint-disable-next-line vue/no-dupe-keys
    wisdomTypeList (type) {
      let that = this
      that.wisdomParams.type = type

      businessTypeList(that.wisdomParams).then(res => {
        that.wisdomDataList = res
        if (that.wisdomDataList.length !== 0) {
          that.content = that.wisdomDataList[0].content
          that.wisdomContent = that.wisdomDataList[0].content
        }
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.srcUrl = require('../../assets/images/customerStories/thinkTanks1.png')
        this.srcUrl1 = require('../../assets/images/customerStories/enterprise2.png')
        this.srcUrl2 = require('../../assets/images/customerStories/wisdom2.png')
        this.thinkTank_visible = true
        this.enterprise_visible = false
        this.wisdom_visible = false
        if (this.businessDataList.length === 0) {
          this.businessTypeList(1)
        } else {
          this.content = this.businessContent
        }
      } else if (tab.name === 'second') {
        this.thinkTank_visible = false
        this.enterprise_visible = true
        this.wisdom_visible = false
        this.srcUrl = require('../../assets/images/customerStories/thinkTanks2.png')
        this.srcUrl1 = require('../../assets/images/customerStories/enterprise1.png')
        this.srcUrl2 = require('../../assets/images/customerStories/wisdom2.png')
        if (this.enterpriseDataList.length === 0) {
          this.EnterpriseList(2)
        } else {
          this.content = this.enterpriseContent
        }
      } else if (tab.name === 'third') {
        this.thinkTank_visible = false
        this.enterprise_visible = false
        this.wisdom_visible = true
        this.srcUrl = require('../../assets/images/customerStories/thinkTanks2.png')
        this.srcUrl1 = require('../../assets/images/customerStories/enterprise2.png')
        this.srcUrl2 = require('../../assets/images/customerStories/wisdom1.png')
        if (this.wisdomDataList.length === 0) {
          this.wisdomTypeList(3)
        } else {
          this.content = this.wisdomContent
        }
      }
    },
    doctor (raw) {
      this.content = raw.content
      if (raw.type === 1) {
        this.businessContent = raw.content
      } else if (raw.type === 2) {
        this.enterpriseContent = raw.content
      } else if (raw.type === 3) {
        this.wisdomContent = raw.content
      }
    }
  },
  created () {
    if (localStorage.getItem('mainBusinessType') === '') {
      this.activeName = 'first'
      this.thinkTank_visible = true
      this.enterprise_visible = false
      this.wisdom_visible = false
      this.srcUrl = require('../../assets/images/customerStories/thinkTanks1.png')
      this.srcUrl1 = require('../../assets/images/customerStories/enterprise2.png')
      this.srcUrl2 = require('../../assets/images/customerStories/wisdom2.png')
      this.businessTypeList(1)
    }
    this.selectCompanyPicture(2)
    this.selectIndustryPicture(3)
    this.selectDoctorPicture(4)
  },
  activated () {
    if (localStorage.getItem('mainBusinessType') === '') {
      this.activeName = 'first'
      this.thinkTank_visible = true
      this.enterprise_visible = false
      this.wisdom_visible = false
      this.srcUrl = require('../../assets/images/customerStories/thinkTanks1.png')
      this.srcUrl1 = require('../../assets/images/customerStories/enterprise2.png')
      this.srcUrl2 = require('../../assets/images/customerStories/wisdom2.png')
      this.businessTypeList(1)
    } else {
      this.activeName = localStorage.getItem('mainBusinessType')
      if (this.activeName === 'first') {
        this.srcUrl = require('../../assets/images/customerStories/thinkTanks1.png')
        this.srcUrl1 = require('../../assets/images/customerStories/enterprise2.png')
        this.srcUrl2 = require('../../assets/images/customerStories/wisdom2.png')
        this.thinkTank_visible = true
        this.enterprise_visible = false
        this.wisdom_visible = false
        if (this.businessDataList.length === 0) {
          this.businessTypeList(1)
        } else {
          this.content = this.businessContent
        }
      } else if (this.activeName === 'second') {
        this.thinkTank_visible = false
        this.enterprise_visible = true
        this.wisdom_visible = false
        this.srcUrl = require('../../assets/images/customerStories/thinkTanks2.png')
        this.srcUrl1 = require('../../assets/images/customerStories/enterprise1.png')
        this.srcUrl2 = require('../../assets/images/customerStories/wisdom2.png')
        this.EnterpriseList(2)
      } else if (this.activeName === 'third') {
        this.thinkTank_visible = false
        this.enterprise_visible = false
        this.wisdom_visible = true
        this.srcUrl = require('../../assets/images/customerStories/thinkTanks2.png')
        this.srcUrl1 = require('../../assets/images/customerStories/enterprise2.png')
        this.srcUrl2 = require('../../assets/images/customerStories/wisdom1.png')
        this.wisdomTypeList(3)
      }
    }
  }
}
</script>

<style lang="less" scoped>

.el-row {
  background-color: #fff;
}
.block{
  .image-slot{
    width: 100%;
    height: 300px;
    margin-bottom: 40px;
  }
}
.grid-content {
  min-height: 20px;
  margin-top: 50px;
  //tobs标题
  .know_item{
    img{
      margin-top: 4px;
    }
  }
  .leftNavigationBar{
    display: block;
    float: left;
    width: 17%;
    li{
      height: 30px;
      text-align: center;
      padding-right:10px ;
      margin-bottom: 15px;
      a{
        display: block;
        height: 30px;
        line-height: 30px;
        width: 100%;
        background-color: #adadad;
        color: #fff;
        border-radius: 12px;
      }
      a:hover{
        background-color: #11a84e !important ;  /*鼠标放上去变颜色*/
      }
      a:active{
        background-color: #11a84e !important ;   /*鼠标点击时变颜色*/
      }
      a:visited{
        background-color: #11a84e !important ;  /*已访问的链接颜色*/
      }
      //a:hover{
      //  background-color: #6aa84f;
      //}
      //a:active{
      //  background-color: #6aa84f; /*已访问的链接颜色*/
      //}
      //a:visited{
      //  background-color: #6aa84f; /*已访问的链接颜色*/
      //}
    }
  }
  .contentArea{
    min-height: 600px;
    display: block;
    float: left;
    width: 83%;
    border: 1px solid #11a84e ;
    padding: 10px;
    border-radius:10px;
    p{
      //text-indent: 2em;
      font-size: 16px;
      color: #000;
    }
  }
}
//Tabs标签页
::v-deep .el-tabs__nav{
  width: 100%;
  font-size: 50px;
}
::v-deep .el-tabs__item {
  padding: 0;
  display: block;
  width: 33.33%;
  float: left;
  font-family: "MicrosoftYaHei";
  text-align: center;
  position: relative;
  height: 80px;
}
//tabs下划线
::v-deep .el-tabs__active-bar{
  background-color: #11a84e;
}
//tabs鼠标移入事件
::v-deep .el-tabs__item:hover{
  color: #11a84e;
}
//tabs鼠标点击事件
::v-deep .el-tabs__item.is-active {
  color: #fff !important;
  background-color:#11a84e !important;
}

//tabs去掉下划线
.el-tabs__nav-wrap::after{
  height:0 !important;
}
::v-deep img{
  max-width:100%;
}
</style>
